/**
 * Recursively removes empty strings and undefined values from objects and arrays
 * @param {any} obj - The object or value to clean
 * @returns {any} - The cleaned object with empty strings and undefined values removed
 */
export default function cleanEmptyValues(obj) {
  // Handle null and undefined
  if (obj === null || obj === undefined) {
    return undefined;
  }

  // Handle empty strings
  if (typeof obj === 'string' && obj === '') {
    return undefined;
  }

  // Handle arrays
  if (Array.isArray(obj)) {
    const cleaned = obj
      .map((item) => cleanEmptyValues(item))
      .filter((item) => item !== undefined && item !== '');
    return cleaned.length > 0 ? cleaned : undefined;
  }

  // Handle objects (but not Date, RegExp, etc.)
  if (typeof obj === 'object' && obj.constructor === Object) {
    const cleaned = {};
    for (const [key, value] of Object.entries(obj)) {
      const cleanedValue = cleanEmptyValues(value);
      // Only include the key if the cleaned value is not undefined or empty string
      if (cleanedValue !== undefined && cleanedValue !== '') {
        cleaned[key] = cleanedValue;
      }
    }
    // Return undefined if object is empty after cleaning
    return Object.keys(cleaned).length > 0 ? cleaned : undefined;
  }

  // Return other values as-is (numbers, booleans, etc.)
  return obj;
}

